export default __webpack_public_path__ + "static/media/CNo.82-4.7d56bb7a.jpg";